<template>
  <div class="comment-basic-box show-flex-box-r" v-if="commentInfoObj">
    <dl class="show-flex-box-r" @click="clickThisComment()">
      <dt class="show-flex-box-r">
        <span class="show-flex-box-r">
          <img :src="commentInfoObj.user && commentInfoObj.user.avatar_url && commentInfoObj.user.avatar_url.o" >
        </span>
      </dt>
      <dd class="show-flex-box-r b-bottom">
        <div class="show-flex-box-r">
          <div class="comment-info-bar">
            <dl class="show-flex-box-c">
              <dt class="show-flex-box-r">
                <strong :class="{'show-flex-box-r': true, 'is-vip': commentInfoObj.user && commentInfoObj.user.is_vip}">
                  <strong class="hide-line1">{{ commentInfoObj.user ? commentInfoObj.user.showname : '' }}</strong>
                </strong>
                <!-- 用户已订阅该课程 就显示该标志 -->
                <h3 class="show-flex-box-r show-flex-center" v-if="commentInfoObj.has_course">
                  <span>已订阅</span>
                </h3>
              </dt>
              <dd class="editor-text show-flex-box-r">
                <html-text :htmlcontent="commentInfoObj.content"></html-text>
              </dd>
              <dd class="show-flex-box-r publish-comment-time-bar">
                <span>{{ dealShowTime(commentInfoObj.created_time) }}</span>
              </dd>
              <dd
                v-if="commentInfoObj.items &&
                      commentInfoObj.items.length > 0 &&
                      commentType == 'reply'"
                class="reply-comment-list-bar show-flex-box-c">
                <div class="show-flex-box-c">
                  <ul class="show-flex-box-c">
                    <li
                      v-for="(item, index) in commentInfoObj.items"
                      :key="index"
                      v-if="index < showReplyNum"
                    >
                      <h3>
                        <span class="show-flex-box-r editor-text">
                          <html-text :htmlcontent="configContent(item.user, item.content)"></html-text>
                        </span>
                      </h3>
                    </li>
                  </ul>
                  <span>共{{ commentInfoObj.items.length }}条回复</span>
                </div>
              </dd>
            </dl>
          </div>
          <!-- <h3 :class="{'show-flex-box-c': true, 'is-like-this-comment': !!commentInfoObj.isPraise}">
            <em
              v-if="commentObj.type == 'video' ||
                    commentObj.type == 'healthyCircle' ||
                    commentObj.type == 'courseSection'"
              @click.stop="changeLikeCommentStatus()"
            ></em>
            <span>{{ commentInfoObj.praiseNum }}</span>
          </h3> -->
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>

import htmlText from "@/components/basic/html_text_comp";
import moment from 'moment';

export default {
  components: {
    htmlText
  },
  props: {
    commentInfo: [Object],
    commentObj: [Object], // type id
    commentType: [String],
  },
  data() {
    return {
      showReplyNum: 2,
      commentInfoObj: null,
    };
  },
  watch: {
    commentInfo: function () {
      this.setShowContent();
    }
  },
  mounted() {
    this.setShowContent();
  },
  methods: {
    setShowContent: function () {
      if(!this.commentInfo){
        return ;
      }

      this.commentInfoObj = this.commentInfo;
    },
    dealShowTime(timestamp){
      if (!timestamp) {
        return '';
      }

      let showTimeStr = '';
      let thisYear = new Date().getFullYear();
      let year = new Date(timestamp * 1000).getFullYear();
      if (thisYear != year) {
        showTimeStr = moment.unix(timestamp).format('YYYY-MM-DD HH:mm');
      } else {
        showTimeStr = moment.unix(timestamp).format('MM-DD HH:mm');
      }
      
    return showTimeStr;
    },
    configContent:function(userInfo, content){
      let userName = userInfo ? userInfo.showname : '';
      let isVipUser = userInfo.isVip;
      let color = isVipUser ? '#BC9253' : '#333333';

      let replyContent = `<span style="font-weight: 700;color: ${color}; word-break: break-all;">${userName}: </span>${content}`;

      return replyContent;
    },
    // 展开评论
    checkAllReply: function () {
      this.showReplyNum = this.commentInfoObj.items.length;
    },
    // 收起评论
    packUpAllReply: function () {
      this.showReplyNum = 2;
    },
    // 点赞
    changeLikeCommentStatus: function () {
      let sendInfo = {
        id: this.commentInfoObj.id,
        isPraise: this.commentInfoObj.isPraise,
        type: this.commentObj.type
      };

      this.$emit('like-this-comment', sendInfo);
    },
    clickThisComment: function () {
      if(this.commentType == 'reply'){
        let sendInfo = {
          commentId: this.commentInfoObj.id,
          courseSectionId: this.commentObj.id, // commentTypeId
          type: 'courseSection',
          userInfo: this.commentInfoObj.user ? this.commentInfoObj.user : null
        };

        this.$emit('open-reply-comment', sendInfo);
      }
    },

  },
};
</script>

<style lang="less">
.comment-basic-box{
  width: 100%;
  > dl {
    width: 100%;
    > dt {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.08rem;
      flex-shrink: 0;
      > span {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
        > img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    > dd {
      width: 0;
      flex-grow: 1;
      padding-bottom: 0.12rem;
      > div{
        width: 100%;
        > .comment-info-bar{
          width: 0;
          flex-grow: 1;
          > dl{
            width: 100%;
            > dt{
              width: 100%;
              align-items: center;
              margin-bottom: 0.04rem;
              > strong{
                // flex-grow: 1;
                max-height: 2.25rem;
                > strong{
                  font-size: 0.14rem;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  line-height: 0.2rem;
                }
              }
              > .is-vip{
                > strong{
                  color: #BC9253;
                }
              }
              > h3{
                box-sizing: border-box;
                flex-shrink: 0;
                margin-left: 0.04rem;
                width: 0.44rem;
                height: 0.18rem;
                border-radius: 0.08rem;
                border: 1px solid #4BDC00;
                > span{
                  font-size: 0.1rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #05BE00;
                  line-height: 0.14rem;
                }
              }
            }
            > dd{
              width: 100%;
            }
            > .publish-comment-time-bar{
              margin-top: 0.06rem;
              > span{
                font-size: 0.12rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 0.17rem;
              }
            }
            > .reply-comment-list-bar{
              width: 100%;
              margin-top: 0.08rem;
              background: #F5F5F5;
              border-radius: 4px;
              > div{
                box-sizing: border-box;
                padding: 0.12rem;
                width: 100%;
                > ul{
                  width: 100%;
                  > li{
                    width: 100%;
                    > h3 {
                      width: 100%;
                      font-size: 0.14rem;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 500;
                      color: #333333;
                      line-height: 0.2rem;
                      > span {
                        width: 100%;
                        word-break: break-all;
                      }
                    }
                  }
                }
                > span {
                  font-size: 0.12rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #05BE00;
                  line-height: 0.17rem;
                  margin-top: 0.02rem;
                }
              }
            }
          }
        }
        > h3{
          margin-top: 0.05rem;
          margin-left: 0.15rem;
          flex-shrink: 0;
          align-items: center;
          > em{
            width: 0.2rem;
            height: 0.2rem;
            flex-shrink: 0;
            background: url('app://assets/course/not_like_icon.png') center center no-repeat;
            background-size: 100% 100%;
          }
          > span{
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 0.17rem;
          }
          > em:active {
            transition: all 0.2s;
            transform: scale(1.1);
          }
        }
        > .is-like-this-comment{
          > em{
            background: url('app://assets/course/is_like_icon.png') center center no-repeat;
            background-size: 100% 100%;
          }
          > span{
            color: #666666;
          }
        }
      }
      .editor-text {
        font-size: 0.14rem !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/comment_comp.vue